import React from 'react'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';

import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom';

import config from "../../config"

import Header from './Header';
import Create_order_nav from './Create_order_nav';
import Create_order_steps from './Create_order_steps';
import Footer from './Footer';
import Create_order_nav_b2b from './Create_order_nav_b2b';
import Create_order_steps_b2b from './Create_order_steps_b2b';


const Create_order_b2b_2 = () => {
    let navigate = useNavigate()
    const location = useLocation()
     let  parsed = queryString.parse(location.search);
     console.log("parsed",parsed);
    const [defaultCountry, setDefaultCountry] = React.useState({country_id:0})

    const [selectedOption, setSelectedOption] = React.useState(null);
   
    const [btnState , setbtnState] = React.useState(true)
    const [options, setOptions] = React.useState([]);
    const [modalState , setModalState] = React.useState({show:false})
    const [addstate1,setaddState] = React.useState({full_name:"" , country_name:244 ,state_name:"" , city_name:"" , pincode:"" , address:"" , email:"" , mobile:"" , err:{} });
    const[addstate , addSetState] = React.useState({sender_country: "",  sender_country_code: "", sender_postal_code: "",sender_state_name:"", sender_city: "", sender_address_id : "",sender_city_id:"", sender_name:"" , sender_mobile:"" , sender_email:"", sender_address: "",receiver_name:"",receiver_email:"",receiver_mobile:"",receiver_address:"",receiver_country: "", receiver_country_code: "", receiver_postal_code: "", receiver_city: "", receiver_state_name:"", mode:"",error:{} });
    // console.log("addstate==== " , addstate)
  
    const [returnstate, setReturnState] = React.useState({return_name:"",return_city:"",return_country_code:"",return_postal_code:"", return_mobile: "", return_address: "", return_email: "",return_state_name:"" , return_country:""})
    // console.log("returnstate === " , returnstate)
  
    const[addressState, setaddressState] = React.useState([]);
    const[selected,setSelected ] = React.useState(null)
  
    const [countryList, setcountryList] = React.useState([]);
    const [stateList, setStateList] = React.useState([]);
    const [cityList, setCityList] = React.useState([]);
    const [pincodeList, setPincodeList] = React.useState([]);
    const[country,setCountry] = React.useState({country_id:""})
    const[state,setState] = React.useState({state_id:""})
    const[city,setCity] = React.useState({city_id:""})
    const[loading , setloading] = React.useState(true)
   
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }

    React.useEffect(()=>{
        address_book_detail()
        getCountryList()
        get_country_list()
      
    },[])
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      const get_country_list = async (value) => {
        // const value = e.target.value;
         
        //  console.log("value--------.....", value)
        
    
         let url = config.apiUrl + '/country/country_list';
     
         // console.log("headers => ", config.headers);
     
         let senddata = {}
        
         axios.post(url, senddata, { headers: config.headers })
           .then((responseJson) => {
              // console.log("responseJson111 => ", responseJson.data);
        
             setDefaultCountry(responseJson.data.defaultCountry)
             setCountry({country_id:responseJson.data.defaultCountry})
             setaddState({...addstate1 , country_name:responseJson.data.defaultCountry})
               getStateList(responseJson.data.defaultCountry)
        
           })
           .catch((error) => {
             //Hide Loader
     
            //  console.error(error);
           });
       };
    const address_book_detail = ()=>{
       if(parsed.order_type==1){
        let url = config.apiUrl + '/country/address_book';
        let sendData = {  customer_id: userData.customer_id };
        // console.log("bb", sendData);
        axios.post(url,sendData ,{headers:config.headers}).then((res)=>{
            if(res.data.status==true){
                // console.log("sasdfdsa")
                let senderInfo = res.data.output
                setaddressState(res.data.output)
                setloading(false)
                if(parsed.sender_address_id!=""){
                  // addSetState({...addstate , sender_name:parsed.sender_name})
                  const matchingSender = senderInfo.findIndex(sender => sender.address_id === parsed.sender_address_id);
                  // console.log("matchingSender === " , matchingSender)
                  setSelected(matchingSender)
                  addSetState({...addstate , sender_country:parsed.sender_country , sender_city:parsed.sender_city , sender_state_name: parsed.sender_state_name , sender_postal_code:parsed.sender_postal_code , sender_country_code:parsed.sender_country_code  , sender_address_id : parsed.sender_address_id  , sender_name:parsed.sender_name , sender_mobile:parsed.sender_mobile , sender_email:parsed.sender_email , sender_address: parsed.sender_address , sender_city_id:parsed.sender_city_id})

                  setReturnState({...returnstate,return_name:parsed.return_name, return_mobile:parsed.return_mobile, return_address:parsed.return_address, return_email:parsed.return_email , return_state_name:parsed.return_state_name , return_city:parsed.return_city , return_country:parsed.return_country , return_country_code:parsed.return_country_code , return_postal_code:parsed.return_postal_code })

                
                }
            }
          
        }).catch(()=>{
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              
              Toast.fire({
                background:"#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
       
           
        })
      }
      else{
        
        let url = config.apiUrl + '/country/address_book_for_fulfilled';
        let sendData = {  customer_id: userData.customer_id };
        // console.log("bb", sendData);
        axios.post(url,sendData ,{headers:config.headers}).then((res)=>{
            if(res.data.status==true){
                // console.log("sasdfdsa")
                let senderInfo = res.data.output
                setaddressState(res.data.output)
                setloading(false)
                if(parsed.sender_address_id!=""){
                  // addSetState({...addstate , sender_name:parsed.sender_name})
                  const matchingSender = senderInfo.findIndex(sender => sender.address_id === parsed.sender_address_id);
                  // console.log("matchingSender === " , matchingSender)
                  setSelected(matchingSender)
                  addSetState({...addstate , sender_country:parsed.sender_country , sender_city:parsed.sender_city , sender_state_name: parsed.sender_state_name , sender_postal_code:parsed.sender_postal_code , sender_country_code:parsed.sender_country_code  , sender_address_id : parsed.sender_address_id  , sender_name:parsed.sender_name , sender_mobile:parsed.sender_mobile , sender_email:parsed.sender_email , sender_address: parsed.sender_address , sender_city_id:parsed.sender_city_id})

                  setReturnState({...returnstate,return_name:parsed.return_name, return_mobile:parsed.return_mobile, return_address:parsed.return_address, return_email:parsed.return_email , return_state_name:parsed.return_state_name , return_city:parsed.return_city , return_country:parsed.return_country , return_country_code:parsed.return_country_code , return_postal_code:parsed.return_postal_code })

                
                }
            }
          
        }).catch(()=>{
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              
              Toast.fire({
                background:"#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
       
           
        })
        
      }
       }
       const addAddress = (value) => {
        setbtnState(false)
          // console.log("value",value)
          let url = config.apiUrl + '/country/add_address_book_second';
             let sendData = { addstate1, customer_id: userData.customer_id };
            //  console.log("bb", sendData);
             let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
             if ( re.test(addstate1.email) ) {
             if(addstate1.full_name!=""  && addstate1.state_name!="" && addstate1.city_name!="" && addstate1.address!="" && addstate1.pincode!="" && addstate1.email!="" && addstate1.mobile!=""  ){
             axios.post(url, sendData, { headers: config.headers }).then((res) => {
               if(res.data.status==true){
                  setModalState({...modalState,show:false})
                  setbtnState(true)
                  setOptions([])
                  setSelectedOption(null)
                  address_book_detail()
                  const Toast = Swal.mixin({
                      toast: true,
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000
                    })
                    
                    Toast.fire({
                      background:"#3659cd",
                      type: 'success',
                      title: "Address Added Successfully",
                      color:"white"
                    });
                  
               }
             }).catch((e) => {
              setbtnState(true)
              setModalState({...modalState,show:false})
  
              const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })
                
                Toast.fire({
                  background:"#a61c09",
                  type: 'unsuccess',
                  title: "Something Went Wrong",
                  color:"white"
                });
         
             });
          }
          
          else{
            setbtnState(true)
              const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })
                
                Toast.fire({
                  background:"#a61c09",
                  type: 'unsuccess',
                  title: "Please Fill All the Details",
                  color:"white"
                });
          }
      }else{
          let itemsR = {...addstate1};
          itemsR.err = {};
            itemsR.err["email"] = true;   
           setaddState(itemsR)
           setbtnState(true)
      }
         }
       const selectAddress =(index , sub)=>{
         setSelected(index)
         addSetState({...addstate , sender_country:sub.country_name , sender_city:sub.city_name , sender_state_name: sub.state_name , sender_postal_code:sub.pincode , sender_country_code:sub.country_code  , sender_address_id : sub.address_id  , sender_name:sub.full_name?sub.full_name:userData.full_name , sender_mobile:sub.mobile , sender_email:sub.email , sender_address: sub.address , sender_city_id:sub.city_id})
         
            setReturnState({...returnstate,return_name:sub.full_name, return_mobile:sub.mobile, return_address:sub.address, return_email:sub.email , return_state_name:sub.state_name , return_city:sub.city_name , return_country:sub.country_name , return_country_code:sub.country_code , return_postal_code:sub.pincode })
            
        
       }
      
      const onChangeLocationstate = (e) => {
        // console.log("e general name ",e.target.name);
        //  console.log("e general value ",e.target.value);
         
         
       let values =   Object.assign({},e.target.value.split(',') )
      //  console.log("first",values[0])
       setState({state_id:values[0]})
       setaddState({...addstate1 , state_name:values[0]})
        getCityList({state_id:values[0], country_id:values[1]})
      
       
      }
      const onChangeLocationcity = (e) => {
        // console.log("e general name ",e.target.name);
        //  console.log("e general value ",e.target.value);
        setCity({city_id:e.target.value})
        setaddState({...addstate1 , city_name:e.target.value})
        setSelectedOption(null)
        setOptions([])
        getPincodeList(e.target.value)
      
       
      }
      const getCountryList = () => {


        let url = config.apiUrl + '/country/country_list';
        let sendData = {limit:300 , status:1};
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("res ", res);           
            setcountryList(res.data.output)
    
    
        }).catch((e) => {
    
    
        });
    }
    const getStateList = (country_id) => {


        let url = config.apiUrl + '/country/state_list';
        let sendData = { t_country_id: country_id, limit: 1000 };
        //  console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("state ", res);           
            setStateList(res.data.output)
    
    
        }).catch((e) => {
    
    
        });
    }
    const getPincodeList = (value) => {
      
        // console.log("value",value)
        let url = config.apiUrl + '/country/pincode_list';
           let sendData = { city_id: value };
          //  console.log("bb", sendData);
           axios.post(url, sendData, { headers: config.headers }).then((res) => {
               // console.log("city  ", res);           
               setPincodeList(res.data.output)
               let data = res.data.output
               const transformedOptions = data.map(item => ({
                value: item.postal_code, // Set the value property based on your data
                label: item.postal_code // Set the label property based on your data
              }));
           setOptions(transformedOptions)
       
       
       
           }).catch((e) => {
       
       
           });
       }
      const getCityList = (value) => {
      
      //  console.log("value",value)
       let url = config.apiUrl + '/country/city_list';
          let sendData = { state_id: value.state_id,country_id:value.country_id, limit: 1000 };
          // console.log("bb", sendData);
          axios.post(url, sendData, { headers: config.headers }).then((res) => {
              // console.log("city  ", res);           
              setCityList(res.data.output)
      
      
          }).catch((e) => {
      
      
          });
      }
     
    const handleSelectChange = selectedOption => {
        setSelectedOption(selectedOption);
        setaddState({...addstate1, pincode:selectedOption})
      };
    
      
    const next_step=()=>{

        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                               if(addstate.sender_name!="" && addstate.sender_address!=""){
                                // if(returnstate.return_name!=""){
                                //     if(returnstate.return_email!=""){
                                //     if(returnstate.return_mobile!=""){
                                //     if(returnstate.return_address!=""){

                                // navigate({
                                //     pathname: parsed.carrier_type==1 && parsed.order_type==1?'/create_order_3':
                                //     // '/customer/create_order_3_fullfilled',
                                //      '/create_order_3_b2b',
                                //     search: `sender_name=${addstate.sender_name}&sender_address=${addstate.sender_address}&sender_country=${addstate.sender_country}&sender_country_code=${addstate.sender_country_code}&sender_postal_code=${addstate.sender_postal_code}&sender_state_name=${addstate.sender_state_name}&sender_city=${addstate.sender_city}&sender_address_id=${addstate.sender_address_id}&sender_city_id=${addstate.sender_city_id}&sender_mobile=${addstate.sender_mobile}&sender_email=${addstate.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&mode=${parsed.mode}&return_name=${returnstate.return_name}&return_email=${returnstate.return_email}&return_mobile=${returnstate.return_mobile}&return_address=${returnstate.return_address}&return_country=${returnstate.return_country}&return_country_code=${returnstate.return_country_code}&return_postal_code=${returnstate.return_postal_code}&return_city=${returnstate.return_city}&return_state_name=${returnstate.return_state_name}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:0}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_city_id=${parsed.receiver_city_id}&receiver_state_id=${parsed.receiver_state_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`
                                //   });
                                  if(parsed.carrier_type==1 &&parsed.order_type==1 ){
                                    window.location.replace(`/create_order_3?sender_name=${addstate.sender_name}&sender_address=${addstate.sender_address}&sender_country=${addstate.sender_country}&sender_country_code=${addstate.sender_country_code}&sender_postal_code=${addstate.sender_postal_code}&sender_state_name=${addstate.sender_state_name}&sender_city=${addstate.sender_city}&sender_address_id=${addstate.sender_address_id}&sender_city_id=${addstate.sender_city_id}&sender_mobile=${addstate.sender_mobile}&sender_email=${addstate.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&mode=${parsed.mode}&return_name=${returnstate.return_name}&return_email=${returnstate.return_email}&return_mobile=${returnstate.return_mobile}&return_address=${returnstate.return_address}&return_country=${returnstate.return_country}&return_country_code=${returnstate.return_country_code}&return_postal_code=${returnstate.return_postal_code}&return_city=${returnstate.return_city}&return_state_name=${returnstate.return_state_name}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:0}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_city_id=${parsed.receiver_city_id}&receiver_state_id=${parsed.receiver_state_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`)
                                  }
                                  else{
                                    window.location.replace(`/create_order_b2b_3?sender_name=${addstate.sender_name}&sender_address=${addstate.sender_address}&sender_country=${addstate.sender_country}&sender_country_code=${addstate.sender_country_code}&sender_postal_code=${addstate.sender_postal_code}&sender_state_name=${addstate.sender_state_name}&sender_city=${addstate.sender_city}&sender_address_id=${addstate.sender_address_id}&sender_city_id=${addstate.sender_city_id}&sender_mobile=${addstate.sender_mobile}&sender_email=${addstate.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&mode=${parsed.mode}&return_name=${returnstate.return_name}&return_email=${returnstate.return_email}&return_mobile=${returnstate.return_mobile}&return_address=${returnstate.return_address}&return_country=${returnstate.return_country}&return_country_code=${returnstate.return_country_code}&return_postal_code=${returnstate.return_postal_code}&return_city=${returnstate.return_city}&return_state_name=${returnstate.return_state_name}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:0}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_city_id=${parsed.receiver_city_id}&receiver_state_id=${parsed.receiver_state_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`)
                                  }
                                
                              
                                 }
                               else{
                                Toast.fire({
                                    background:"#a61c09",
                                    type: 'unsuccess',
                                    title: "Please Select Sender Detail",
                                    color:"white"
                                  });
                               }
                           
    }
    

    
    const onhide=()=>{
      setModalState({ show: false })
      setaddState({...addstate1, full_name:""  ,state_name:"" , city_name:"" , pincode:"" , address:"" , email:"" , mobile:"" , warehouse_name:"", err:{} })
       setSelectedOption(null)
      setOptions([])
      setState([])
      setCityList([])
      setPincodeList([])
      setCountry({country_id:""})
      setState({state_id:""})
      setCity({city_id:""})

     }
     const handleChange1 =(e)=>{
      setaddState({...addstate1, [e.target.name]:e.target.value , err:{}})
      
   }
  return (
    <div>
   <Header/>
<div class="page-wrapper pinned">
 <div class="main-container">
  <div className='app-container'>
 <div class="app-body">
 <div class="container-fluid"> 

<div class="mob_nav">
  <div class=" d-flex justify-content-start ">
    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
    <h2>Create Order</h2>
  </div>
</div>

<div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>Create Order</h2>
      </div>
    </div>
    
</div>
<Create_order_nav_b2b/>
<hr/>
<div class="row">
    <div class="col-12 col-md-2">
  <Create_order_steps_b2b value={2}/>
    </div>
    <div class="col-12 col-md">
      <h4 class="pb-3">Pickup Address</h4>
      <div class="card border-0 order_box">
        <div class="card-body">
          <section class="pb-2">
            <h6 class="mb-4">Where is the order being sent from? <span class="text-muted">(Your Address)</span></h6>
            {/* <div class="row">
                <div class="col-12 col-md-12 mb-3">
                    <div class="input-group input-group-lg">
                        <span class="input-group-text"><i class="bi bi-search"></i></span>
                        <input type="text" class="form-control" placeholder="Search your pickup address by name, mobile number"/>
                    </div>
                </div>
            </div> */}
          </section>
          <hr/>
          <Modal show={modalState.show} onHide={() => onhide()} size='lg'>
<Modal.Header closeButton>
                    <Modal.Title>
                   
        <h4 class="modal-title">Create Warehouse</h4>
       
    
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                <div className='row'>
                    <div className='col-6'>
                        <label>Full Name <span class="text-danger">*</span></label>
                        <input className='form-control mt-2' type='text' placeholder='Enter Full Name' name="full_name" autoComplete='off' onChange={(e)=>handleChange1(e)}/>
                    </div>
                    {/* <div className='col-6'>
                        <label>Warehouse Name <span class="text-danger">*</span></label>
                        <input className='form-control mt-2' type='text' placeholder='Enter Warehouse Name' name="warehouse_name" autoComplete='off' onChange={(e)=>handleChange(e)}/>
                    </div> */}
                  
                </div>
                <div className='row mt-3'>
                    {/* <div className='col-3 country' >
                    <label for="" class="form-label">Select Country: <span class="text-danger">*</span></label>
          <select class="form-select" name="country_name" onChange={(e)=>onChangeLocationGeneral(e)}>
            <option>Select</option>
            {countryList.map((item)=>{
            return (
              <option value={item.country_id}>{item.country_name}</option>
          )
           
})}
</select>
                    </div> */}
                    <div className='col-3'>
                    <label for="" class="form-label">Select State: <span class="text-danger">*</span></label>
          <select class="form-select"  name="state_name" onChange={(e)=>onChangeLocationstate(e)}>
            <option>Select</option>
            {stateList.map((item)=>{
            return (
              <option value={[item.state_id,item.country_id]}>{item.state_name}</option>
          )
           
})}
          
          </select>
                    </div>
                    <div className='col-3'>
                    <label for="" class="form-label">Select City: <span class="text-danger">*</span></label>
                    <select class="form-select" name="city_name" onChange={(e)=>onChangeLocationcity(e)}>
            <option >Select</option>
            {cityList.map((item)=>{
            return (
              <option value={item.city_id}>{item.city_name}</option>
          )
           
})}
          </select>
                    </div>
                    <div className='col-3'>
                    <label for="" class="form-label">Select Pincode: <span class="text-danger">*</span></label>
                  
      
      <Select
      
        options={options}
        value={selectedOption}
        onChange={(e)=>handleSelectChange(e)}
        isClearable={true}
        name="pincode"
      />
           
          
      
                    </div>

                </div>

                <div className='row '>
                    <div className='col-12'>
                        <label>Address <span class="text-danger">*</span></label>
                        <input className='form-control mt-2' placeholder='Enter Address' type='text' name="address" autoComplete='off' onChange={(e)=>handleChange1(e)}/>
                    </div>
                </div>
                <div className='row '>
                    <div className='col-6'>
                        <label>Email <span class="text-danger">*</span></label>
                        <input className='form-control mt-2' type='email' placeholder='Enter Email' name="email" autoComplete='off' onChange={(e)=>handleChange1(e)} />
                        {(addstate1.err.email)?
                            <>
                            <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                            lineHeight: "1.66667",
                            fontWeight: "400",
                            letterSpacing: "0.05em",marginLeft:"4px"}}>Please Fill Valid Email</small></>:""}
                    </div>
                    <div className='col-6'>
                        <label>Mobile # <span class="text-danger">*</span></label>
                        <input className='form-control mt-2' type='number' placeholder='Enter Mobile Number' name="mobile" autoComplete='off' onChange={(e)=>handleChange1(e)}/>
                    </div>
                </div>
                <hr/>
      <div class="p-3 text-center">
      {btnState==true?  <a  class="btn btn-primary" onClick={() => addAddress()}>Create Warehouse</a>:""}
      </div>
                </Modal.Body>
              
            </Modal> 
          <section class="pb-2">
            <h6 class="mb-4">Recently Used Addresses</h6>
            <div class="row address_box_s">
            {addressState.map((sub , index)=>(
                <div class="col-6 col-md-4 mb-3">
                    <a style={{cursor:"pointer"}} onClick={()=>selectAddress(index , sub)}>
                      <div  class={selected == index?"card bg-light shadow-sm active":"card bg-light shadow-sm"}>
                        <div class="card-body">
                        {sub.primary==true?   <span class="badge rounded-pill bg-primary">Primary Address</span>:""}
                          <h6 class="pt-3">{sub.warehouse_id?sub.warehouse_id:sub.warehouse_name}</h6>
                          <small>{sub.address} , {sub.city_name} , {sub.state_name} , {sub.pincode}</small><br/>
                          <small>Mobile: {sub.mobile}</small>
                        </div>
                      </div>
                    </a>
                </div>
               ))}
            </div>
          </section>
          <hr/>
          {parsed.order_type==1?
          <section class="pb-2">
            <h6 class="mb-4">Other Addresses</h6>
            <div class="row address_box_s">
                <div class="col-12 col-md-4 mb-3">
                    <a onClick={() => setModalState({ show: true })}>
                      <div class="card bg-light shadow-sm ">
                        <div class="card-body address_add d-flex align-items-center justify-content-center">
                          <div class="text-primary text-center">
                          <i class="bi bi-geo-alt"></i>
                            <h6>Add New Pickup Address</h6>
                          </div>
                        </div>
                      </div>
                    </a>
                </div>
            </div>
          </section>
           :""}
        </div>
      </div>
      <div class="py-4 text-end">
          <a  
          // onClick={()=>navigate({
          //                           pathname: '/create_order_1',
          //                           search: `value=${parsed.mode=="Domestic"?0:1}&sender_name=${addstate.sender_name}&sender_address=${addstate.sender_address}&sender_country=${addstate.sender_country}&sender_country_code=${addstate.sender_country_code}&sender_postal_code=${addstate.sender_postal_code}&sender_state_name=${addstate.sender_state_name}&sender_city=${addstate.sender_city}&sender_address_id=${addstate.sender_address_id}&sender_city_id=${addstate.sender_city_id}&sender_mobile=${addstate.sender_mobile}&sender_email=${addstate.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&mode=${parsed.mode}&return_name=${returnstate.return_name}&return_email=${returnstate.return_email}&return_mobile=${returnstate.return_mobile}&return_address=${returnstate.return_address}&return_country=${returnstate.return_country}&return_country_code=${returnstate.return_country_code}&return_postal_code=${returnstate.return_postal_code}&return_city=${returnstate.return_city}&return_state_name=${returnstate.return_state_name}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:0}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_state_id=${parsed.receiver_state_id}&receiver_city_id=${parsed.receiver_city_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`
          //                         })} 
          href={`/create_order_1?value=${parsed.mode=="Domestic"?0:1}&sender_name=${addstate.sender_name}&sender_address=${addstate.sender_address}&sender_country=${addstate.sender_country}&sender_country_code=${addstate.sender_country_code}&sender_postal_code=${addstate.sender_postal_code}&sender_state_name=${addstate.sender_state_name}&sender_city=${addstate.sender_city}&sender_address_id=${addstate.sender_address_id}&sender_city_id=${addstate.sender_city_id}&sender_mobile=${addstate.sender_mobile}&sender_email=${addstate.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&mode=${parsed.mode}&return_name=${returnstate.return_name}&return_email=${returnstate.return_email}&return_mobile=${returnstate.return_mobile}&return_address=${returnstate.return_address}&return_country=${returnstate.return_country}&return_country_code=${returnstate.return_country_code}&return_postal_code=${returnstate.return_postal_code}&return_city=${returnstate.return_city}&return_state_name=${returnstate.return_state_name}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:0}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_state_id=${parsed.receiver_state_id}&receiver_city_id=${parsed.receiver_city_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`}
                                  class="btn btn-secondary me-2">Back</a>
          <a onClick={()=>next_step()} class="btn btn-primary">Next</a>
      </div>
    </div>
</div>






    </div>
    </div></div>
    <Footer/>
    </div></div>
    </div>
  )
}

export default Create_order_b2b_2
